import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    currentLoading;
    constructor(
        private loadingController: LoadingController
    ) { }

    async createLoading(messageInput: string) {
        if (!this.currentLoading) {
            this.currentLoading = await this.loadingController
                .create({
                    message: messageInput
                });
            await this.currentLoading.present();
        }
    }

    async dismissLoading() {
        if (this.currentLoading) {
            await this.currentLoading.dismiss();
            this.currentLoading = undefined;
        }
    }

    async createAutoLoading(messageInput: string, durationInput: number) {
        if (!this.currentLoading) {
            this.currentLoading = await this.loadingController
                .create({
                    message: messageInput,
                    duration: durationInput
                });
            this.currentLoading.dismiss();
            this.currentLoading = undefined;
        }
    }
}
